import {
    useGetCompanyArticlesQuery,
    useGetCompanyQuery,
    useGetWidgetConfigurationsQuery,
} from '@/store/apiService';
import { TAKE_ITEMS } from '@/env/environment';
import { resolveEmbedScriptUrl } from '@/containers/widget/embedScriptUrl';
import { CompanyArticle } from '@/types/types';
import { hasConfigurationId, StoredConfiguration } from './embedPageState';

export interface CompanyEmbedData {
    companySitepath: string;
    embedScriptUrl: string;
    configurations: StoredConfiguration[];
    articles: CompanyArticle[];
    articlesTotal: number;
    companyError?: unknown;
    isLoading: boolean;
}

export const useCompanyEmbedData = (companyId: string | undefined): CompanyEmbedData => {
    const skip = !companyId;
    const companyResult = useGetCompanyQuery({ Id: companyId! }, { skip });
    const configurationsResult = useGetWidgetConfigurationsQuery(
        { CompanyId: companyId! },
        { skip }
    );
    const articlesResult = useGetCompanyArticlesQuery(
        {
            CompanyId: companyId!,
            IncludeServiceInformation: true,
            Skip: 0,
            Take: TAKE_ITEMS,
            OrderBy: 'SortOrder,Name',
        },
        { skip }
    );

    return {
        companySitepath: (companyResult.data?.SitePath ?? '').toLowerCase(),
        embedScriptUrl: resolveEmbedScriptUrl(companyResult.data?.SitePath),
        configurations: (configurationsResult.data?.Results ?? []).filter(hasConfigurationId),
        articles: articlesResult.data?.Results ?? [],
        articlesTotal: articlesResult.data?.Total ?? 0,
        companyError: companyResult.error,
        isLoading: companyResult.isLoading || configurationsResult.isLoading,
    };
};
